export default "__VITE_ASSET__DHbNxBAQ__"